/**
 * Curated everyday English lexicon shared by the arcade word games: the English twin of turkish-words.ts.
 * EN_WORDS is the 3–6-letter list (Kaçış target words, Harf Kulesi level words); EN_YILAN_WORDS adds a
 * long-word layer for Harf Yılanı. Studio-written, no external dictionary is bundled. Family-friendly:
 * no proper names, slurs, violence, alcohol or body jokes.
 */

export const EN_ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

const RAW = `
ant ape arm art axe bag bat bed bee box boy bus cab cap car cat cow cub cup dad day den dog dot ear egg elf
elk end eye fan fig fin fir fix fly fog fox fun gem gum hat hen hip hog hop hot hug hut ice ink jam jar jet
joy key kid kit lab leg lid lip log map mat mix mom mop mud mug net nut oak oar owl pan paw pea pen pet pie
pig pin pod pot pup ram rat red rib rod rug run saw sea sip sit sky sun tab tag tan tap tea ten tin tip toe
top toy tub tug van vet web wig win wok yak yam zip zoo age air ash bow bun cod dew elm emu ewe ivy oat
one owe rye sew sow two use yes

baby back bake ball band bank barn bath bead beak bean bear bell belt bike bird boat bone book boot bowl
bulb cake calm camp card cart cave chef city clay coat coin cold comb cook corn crab crow cube cute dark
deer desk dice dish doll door dove drum duck dust easy echo farm fast fern film fish flag foam fork frog
game gate gift girl glue goal goat gold golf hair hand harp hawk herb hero hill home hook horn idea iron
jump kind king kite kiwi lake lamb lamp leaf lime lion list loaf lock love mail mask meal milk mint moon
moss nest nose note oven page palm park pear pink plan play plum pond pool rain rice ring road rock roof
rope rose sail salt sand seed ship shoe shop silk sing snow soap sock sofa soup star swan tail taxi tent
tide time tree tune vase wave wind wing wish wolf wood wool yard yarn zero zone aunt bark blue cozy dime
dune fair fawn fire foal gown hive jade kelp lace lark lily mane mole mule nail oboe pace peak pony puff
quiz reed seal shed sled slug snap soil team toad tuba vine wren

acorn amber angel apple arrow badge bagel baker basil beach bench berry bison bloom board brave bread
brick brush bunny cabin camel candy chair chalk cheek chess cider cloud clown cocoa coral couch crane
crisp crown daisy dance dream eagle earth fairy feast field flame float flour flute frost fruit ghost
giant globe grape grass green happy heart honey horse house igloo jelly juice kayak koala laugh lemon
light llama lucky magic mango maple melon mouse movie music novel nurse ocean olive onion otter paint
panda paper party peace peach pearl penny petal piano pilot pizza plant plate poppy puppy queen quiet
quilt radio raven river robin robot salad scarf seeds shark sheep shell shirt skate sleep slide smile
snack snail solar spice spoon sport stamp stone storm sugar sunny sweet swing table teeth thumb tiger
toast torch towel tower trail train treat truck tulip uncle video wagon water waves whale wheat windy
world yacht zebra

animal anchor autumn banana basket beetle bottle bridge bubble bucket butter button camera candle canyon
carrot castle cereal cheese cherry circle cookie cotton crayon dinner donkey dragon engine flower forest
friend garden ginger gloves guitar hammer helmet island jacket jungle kettle kitten ladder lagoon lizard
magnet marble meadow melody mirror monkey muffin nature noodle orange orchid oyster paddle parade parrot
pebble pencil pepper pickle pillow pirate planet pocket potato puppet puzzle rabbit ribbon rocket saddle
salmon school shovel silver singer sketch sleigh spider spring stream summer sunset teapot ticket tomato
travel tunnel turtle velvet violin voyage wallet walnut window winter wizard yellow zipper
`;

const isEnglish = (word: string): boolean => /^[A-Z]+$/.test(word);

/** Uppercase, deduplicated, 3–6 letters, in list order. */
export const EN_WORDS: readonly string[] = Array.from(new Set(RAW.split(/\s+/).filter(Boolean).map((w) => w.toUpperCase()))).filter(
  (w) => isEnglish(w) && w.length >= 3 && w.length <= 6,
);

/** Hand-curated longer everyday words for Harf Yılanı; no proper names. */
const YILAN_LONG_RAW = `
airplane backpack baseball birthday blanket blueberry butterfly calendar campfire caterpillar chicken
chocolate computer cucumber dinosaur dolphin elephant envelope festival fireworks football friendship
giraffe grandmother hamburger hedgehog holiday kangaroo kitchen lantern lemonade library lighthouse
marshmallow monster morning mountain mushroom notebook octopus orchard pancake penguin picture pineapple
playground popcorn pumpkin rainbow rainforest raspberry sandcastle sandwich scarecrow snowflake spaceship
strawberry submarine sunflower sunshine teacher telescope thunder toothbrush tractor treasure umbrella
unicorn vacation volcano waterfall watermelon weather whistle
`;

export const EN_YILAN_WORDS: readonly string[] = Array.from(
  new Set([...EN_WORDS, ...YILAN_LONG_RAW.split(/\s+/).filter(Boolean).map((w) => w.toUpperCase())]),
).filter((word) => isEnglish(word) && word.length >= 3 && word.length <= 14);
